module.exports = __webpack_public_path__ + "static/media/miwa_card_read_error.f6ef5895.svg";